module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lAywc"))).then(() => parcelRequire('d0iPb'));